export const ActionTypes = {};
for (let actionType of ["SET_PERMISSIONS", "SET_ACTIVE_TIMER"]) {
  ActionTypes[actionType] = actionType;
}
